import React from 'react';
import styled, { css } from 'styled-components';
import { observer, inject } from 'mobx-react';
import YInput from '../../../component/YInput';

const Step2 = inject('stepStore')(observer((props: any) => {
  return (
    <Container>
      {/*<h2>联系方式</h2>*/}
      <form>
        <YInput label='联系姓名' name='name' require={true}/>
        <YInput label='联系电话' name='mobile' require={true}/>
        <YInput label='微信账号' name='wx' require={true}/>
        <YInput label='QQ账号' name='qq'/>
        <YInput label='邮箱账号' name='email'/>
      </form>
      <Buttons>
        <Button active onClick={() => props.stepStore.changeStep(1)}>上一步</Button>
        <Button active={props.stepStore.canSubmit} onClick={() => props.stepStore.changeStep(3)}>提交</Button>
      </Buttons>
    </Container>
  )
}))

export default Step2;

const Container = styled.div`
  width: 870px;
  margin: 0 auto;
  h2{
    font-size:20px;
    color:rgba(25,103,250,1);
    line-height:25px;
    margin-bottom: 18px;
  }
`

interface IButton {
  active?: boolean
  normal?: boolean
}

const activeButton = css`
  background: #fff;
  /* box-shadow:0 8px 30px 0 rgba(25,104,252,0.3); */
  border: 1px solid #216DF3;
  color: #216DF3;
  &:hover{
    background: #1968FC;
    box-shadow: 0px 10px 40px 0px rgba(25, 104, 252, 0.3);
    color: #fff;
  }
`

const normalButton = css`
  background:rgba(196,196,196,1);
  /* box-shadow:0 8px 30px 0 rgba(176,176,176,0.3); */
`
const Button = styled.button`
  border: none;
  width:230px;
  height:50px;
  /* border-radius:4px; */
  font-size:18px;
  /* font-weight:bold; */
  color:rgba(255,255,255,1);
  outline: none;
  &:hover{
    transition: all 0.3s linear;
    transform: scale(1.2);
  }
  
  ${(props: IButton) => props.active ? activeButton : normalButton}

  &+button{
    margin-left: 24px;
  }
`
const Buttons = styled.div`
  margin-top: 229px;
  text-align: center;
`